export default function scrollTo (to) {
  window.scroll({
    top: to === 'top' ? 0 : top,
    left: 0,
    behavior: 'smooth'
  })
}


// WEBPACK FOOTER //
// ./src/helpers/scroll-to.js